<template>
    <div class="app_detail">
        <img class="head_photo" :src="productData.headPhotoUrl" alt="">
        <div class="descript">
            <div>
                <div>
                    <span>¥{{productData.groupPrice}}</span>
                    <span>{{productData.buyerCount}}人团</span>
                </div>
                <span>原价¥{{productData.originPrice}}</span>                
            </div>
            <div v-if="productData.grade">{{productData.grade}}专属</div>
        </div>
        <div class="title_intro">
            <div>
                <p class="title">{{productData.groupName}}</p>
                <p class="subtitle">{{productData.groupDesc}}</p>                
            </div>
            <div @click="toggleServiceClick">
                <ul>
                    <li v-for="(item, index ) in productData.serviceList" :key="index">
                        <img src="https://appd.knowbox.cn/ss/activity/group-buy/icon-tick.png" alt="">
                        <span>{{item.title}}</span>
                    </li>
                </ul>
                <span >...</span>
            </div>
        </div>
        <div v-if="productData.courseTimes && productData.courseTimes.length !==0 " class="course_time" id="course_time">
            <span>选择</span>
            <span id="select_time">{{ productData.courseTimes && productData.courseTimes.length !==0 ? productData.courseTimes[0].time: '' }}</span>
            <span></span>
        </div>
        <div class="group_intro" @click="toggleRuleClick">
            <div class="group_num">
                <div class="profile_photo" v-if="productData.bubbleList">
                    <img v-for="(item, index ) in productData.bubbleList.slice(0, 3)" :key="index"  :src="item.headPhoto" alt="">
                </div>
                <div class="num">
                    <p><span>{{productData.groupNumber}}</span>人</p>
                    <p>已经拼团成功</p>
                </div>
            </div>
            <div class="rule" >
                <span>拼团规则</span>
                <span>...</span>
            </div>
        </div>
        <div class="course_detail">
            <!-- <p class="title">课<span>/</span>程<span>/</span>详<span>/</span>情</p> -->
            <img v-for="(item, index ) in productData.groupDescImgList" :key="index"  :src="item"  alt="">
        </div>
        <div v-if="productData.bubbleList" :class="['purchased_bubble',bubbleRadom && 'active']" >
          <img :src="person.headPhoto" alt="">
          <span class="name">{{person.username}}</span>
          <span>已拼团成功</span>            
        </div> 
        <rule :groupRule="productData.groupRule" v-show="ruleIsShow" @footerClick="toggleRuleClick"/>
        <service :serviceList="productData.serviceList" v-show="serviceIsShow" @footerClick="toggleServiceClick"/>
        <div class="container"></div>
    </div>
</template>

<script>
// import utils from "@/assets/js/utils";
import rule from "./rule.vue";
import service from "./service.vue";
import "../../../../static/iosSelect.js";

export default {
  name: "app_detail",
  props: {
    productData: Object
  },
  data() {
    return {
      serviceIsShow: false,
      ruleIsShow: false,
      person: {},
      bubbleRadom: false,
      backData: []
    };
  },
  components: {
    rule,
    service
  },
  methods: {
    toggleRuleClick() {
      this.ruleIsShow = !this.ruleIsShow;
    },
    toggleServiceClick() {
      this.serviceIsShow = !this.serviceIsShow;
    },
    randombubble() {
      let i = 0;
      this.person = this.productData.bubbleList[i];
      setInterval(() => {
        i++;
        this.bubbleRadom = true;
        if (i > this.productData.bubbleList.length - 1) {
          i = 0;
        }
        this.person = this.productData.bubbleList[i];
      }, 2000);
    },
    getBackData() {
      this.backData = this.productData.courseTimes.map(item => {
        return { id: item.phaseId, value: item.time };
      });
    }
  },
  computed: {},
  watch: {
    productData() {
      console.log("this.productData.courseTimes", this.productData.courseTimes);
      this.randombubble();
      //延时处理；
      setTimeout(() => {
        this.getBackData();
        var showTimeDom = document.querySelector("#course_time");
        var timeDom = document.querySelector("#select_time");
        var that = this;
        showTimeDom &&
          showTimeDom.addEventListener("click", function() {
            console.log("that.backData", that.backData);
            var bankId = showTimeDom.dataset["id"];
            new window.IosSelect(1, [that.backData], {
              container: ".container",
              title: "选择上课时间",
              // headerHeight: 100,
              // itemHeight: 90,
              itemShowCount: 5,
              oneLevelId: bankId,
              showAnimate: true,
              // cssUnit: 'rem',
              callback: function(selectOneObj) {
                timeDom.value = selectOneObj.id;
                timeDom.innerHTML = selectOneObj.value;
                showTimeDom.dataset["id"] = selectOneObj.id;
                showTimeDom.dataset["value"] = selectOneObj.value;
                that.$emit("selectTime", selectOneObj.id);
              }
            });
          });
      }, 500);
    }
  },
  created: function() {},
  mounted() {}
};
</script>

<style scoped lang="scss">
@import "../../../../static/iosSelect.css";
.app_detail {
  .head_photo {
    width: 100%;
    height: auto;
    background-color: #000000;
    display: block;
  }
  .descript {
    width: 100%;
    height: 0.9rem;
    background-image: linear-gradient(-90deg, #ff7575 0%, #ff4b4b 100%);
    display: flex;
    justify-content: space-between;
    padding: 0 0.26rem 0 0.3rem;
    color: #ffffff;
    > div {
      &:nth-child(1) {
        display: flex;
        flex-direction: column;
        justify-content: center;
        div {
          font-family: PingFangSC-Semibold;
          height: 0.42rem;
          display: flex;
          align-items: center;
          span:nth-child(1) {
            font-size: 0.42rem;
            line-height: 0.32rem;
            margin-right: 0.1rem;
            font-weight: bolder;
          }
          span:nth-child(2) {
            height: 0.28rem;
            line-height: 0.3rem;
            background-color: #ffffff;
            border-radius: 0.14rem;
            padding: 0 0.1rem;
            color: #ff5c5c;
            font-size: 0.2rem;
          }
        }
        > span {
          display: block;
          line-height: 0.2rem;
          font-family: PingFangSC-Light;
          font-size: 0.2rem;
          color: #ffffff;
          margin-top: 0.07rem;
          text-decoration: line-through;
        }
      }
      &:nth-child(2) {
        margin-top: 0.32rem;
        font-size: 0.22rem;
        color: #ffffff;
      }
    }
  }
  .title_intro {
    width: 100%;
    padding: 0 0.3rem;
    background: #fff;
    margin-bottom: 0.2rem;
    div {
      &:nth-child(1) {
        border-bottom: 0.01rem solid #f0f0f0;
        .title {
          font-family: PingFangSC-Semibold;
          font-size: 0.4rem;
          height: 0.8rem;
          line-height: 0.4rem;
          color: #424243;
          padding-top: 0.39rem;
          font-weight: bolder;
          margin-bottom: 0.1rem;
        }

        .subtitle {
          font-family: PingFangSC-Regular;
          font-size: 0.26rem;
          color: #919294;
          margin-top: 0.05rem;
          margin-bottom: 0.26rem;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
      &:nth-child(2) {
        display: flex;
        height: 0.6rem;
        justify-content: space-between;
        color: #919294;
        ul {
          overflow: hidden;
          li {
            height: 0.6rem;
            line-height: 0.6rem;
            float: left;
            display: flex;
            align-items: center;
            img {
              width: 0.24rem;
              height: 0.24rem;
              margin-right: 0.05rem;
            }
            span {
              font-family: PingFangSC-Regular;
              font-size: 0.22rem;
              margin-right: 0.3rem;
            }
          }
        }
        > span {
          margin-top: 0.06rem;
          font-size: 0.28rem;
          color: #bec0c2;
          font-weight: bolder;
        }
      }
    }
  }
  .course_time {
    width: 100%;
    height: 1.1rem;
    line-height: 1.1rem;
    background-color: #ffffff;
    color: #424243;
    font-family: PingFangSC-Regular;
    font-size: 0.28rem;
    padding: 0 0.3rem;
    margin-bottom: 0.2rem;
    span {
      &:nth-child(1) {
        color: #919294;
        font-family: PingFangSC-Regular;
        font-size: 0.24rem;
        margin-right: 0.28rem;
      }
      &:nth-child(3) {
        width: .10rem;
        height: .17rem;
        background: url(https://appd.knowbox.cn/ss/activity/group-buy/arrows.png) no-repeat;
        background-size: 100% 100%;
        float: right;
        display: inline-block;
        margin-top: .45rem;
      }
    }
  }
  .group_intro {
    height: 1.1rem;
    background-color: #ffffff;
    padding: 0 0.3rem;
    border-bottom: 1px solid #f0f0f0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #919294;
    font-size: 0.24rem;
    .group_num {
      display: flex;
      align-items: center;
      margin-top: 0.1rem;
      .profile_photo {
        margin-right: 0.24rem;
        img {
          width: 0.64rem;
          height: 0.64rem;
          border-radius: 0.64rem;
          // background-color: #000000;
          border: solid 0.04rem #ffffff;
          margin-right: -0.14rem;
          box-shadow: 0rem 0.02rem 0.09rem 0.01rem rgba(0, 0, 0, 0.07);
        }
      }
      .num {
        p {
          height: 0.25rem;
          line-height: 0.25rem;
          span {
            color: #5f6162;
          }
          &:nth-child(1) {
            margin-bottom: 0.04rem;
          }
        }
      }
    }
    .rule {
      display: flex;
      align-items: center;
      span {
        &:nth-child(1) {
          margin-right: 0.19rem;
        }
        &:nth-child(2) {
          margin-bottom: 0.14rem;
          font-size: 0.28rem;
          color: #bec0c2;
          font-weight: bolder;
        }
      }
    }
  }
  .course_detail {
    background: #fff;
    padding-bottom: 1rem;
    .title {
      font-family: PingFangSC-Semibold;
      font-size: 0.36rem;
      color: #424243;
      text-align: center;
      letter-spacing: 0.3rem;
      height: 0.36rem;
      line-height: 0.36rem;
      margin-bottom: 0.4rem;
      span {
        color: #ccc;
        font-size: 0.3rem;
      }
    }
    img {
      width: 100%;
      display: block;
    }
  }
  .purchased_bubble {
    height: 0.6rem;
    background-color: rgba($color: #000000, $alpha: 0.5);
    border-radius: 0.3rem;
    font-family: PingFangSC-Medium;
    font-size: 0.22rem;
    color: #ffffff;
    position: fixed;
    bottom: 1.2rem;
    left: 0.3rem;
    display: flex;
    align-items: center;
    padding: 0 0.21rem 0 0.06rem;
    img {
      width: 0.48rem;
      height: 0.48rem;
      border-radius: 0.48rem;
      // background-color: #000000;
      box-shadow: 0px 2px 9px 1px rgba(0, 0, 0, 0.07);
      border: solid 2px #ffffff;
    }
    .name {
      margin: 0 0.1rem;
    }
  }
  .purchased_bubble.active {
    animation: mymove 2s infinite;
    -webkit-animation: mymove 2s infinite; /*Safari and Chrome*/
  }
  @keyframes mymove {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @-webkit-keyframes mymove /*Safari and Chrome*/ {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  .footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1rem;
    .purchase {
      &_0 {
        display: flex;
        height: 1rem;
        div {
          &:nth-child(1) {
            background: #fff;
            width: 2.7rem;
            font-size: 0.24rem;
            color: #919294;
            font-family: PingFangSC-Medium;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            span:nth-child(1) {
              font-size: 0.36rem;
              color: #ff7575;
              height: 0.4rem;
            }
          }
          &:nth-child(2) {
            font-size: 0.24rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            background-color: #ff5c5c;
            width: 4.8rem;
            color: #ffffff;
            span:nth-child(1) {
              font-size: 0.36rem;
              height: 0.4rem;
            }
          }
        }
      }
      &_1 {
        height: 1rem;
        line-height: 1rem;
        text-align: center;
        background-color: #ff5c5c;
        font-family: PingFangSC-Medium;
        font-size: 0.34rem;
        color: #ffffff;
      }
      &_2 {
        height: 1rem;
        line-height: 1rem;
        text-align: center;
        background-color: #fff;
        font-family: PingFangSC-Medium;
        font-size: 0.34rem;
        color: #ff5c5c;
      }
      &_3 {
        height: 1rem;
        line-height: 1rem;
        text-align: center;
        background-color: #d2d3d4;
        font-family: PingFangSC-Medium;
        font-size: 0.34rem;
        color: #fff;
      }
    }
  }
}
/*iPhone X XS 2436x1125px at 458ppi */
@media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
  .app_detail {
    .purchased_bubble {
      bottom: 1.6rem;
    }
  }
}

/*iPhone XR 1792x828px at 326ppi */
@media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) {
  .app_detail {
    .purchased_bubble {
      bottom: 1.6rem;
    }
  }
}

/* iPhone XS Max 2688x1242px at 458ppi */
@media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) {
  .app_detail {
    .purchased_bubble {
      bottom: 1.6rem;
    }
  }
}

</style>